export default function WishlistHeader({ count }) {
  return (
    <header className="rounded-[2rem] bg-foreground px-6 py-12 text-background shadow-2xl shadow-black/15 sm:px-10 lg:px-14">
      <p className="text-xs font-black uppercase tracking-[0.35em] text-background/60">
        Saved Items
      </p>

      <h1 className="mt-4 text-4xl font-black uppercase tracking-tight sm:text-6xl">
        Wishlist
      </h1>

      <p className="mt-4 max-w-2xl text-sm leading-7 text-background/70">
        Your favorite Captex products saved in one premium space.
      </p>

      <p className="mt-6 text-sm font-semibold">
        {count} {count === 1 ? "item" : "items"} saved
      </p>
    </header>
  );
}